// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"c8b0c18e","59":"141ea0f4","273":"d36a5897","309":"21d393f1","416":"198ed60a","519":"f4737f49","617":"a88cbdef","673":"32634b23","728":"db3f8070","834":"817a3df1","949":"7f3ec780","951":"48500e5f","993":"7ef71c0b"}[chunkId] + ".chunk.js";
};